import { render, staticRenderFns } from "./CategoryCategory.vue?vue&type=template&id=1c1e038d&"
import script from "./CategoryCategory.vue?vue&type=script&lang=js&"
export * from "./CategoryCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports